import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";

const ArtistRights = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom>
            Privacy Policy
          </Typography>
          <Typography variant="body1" gutterBottom>
            This Privacy Policy explains how Lsnto collects, uses, and protects your data. We are currently in a pre-launch phase and may revise this policy as the platform evolves.
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Information We Collect
          </Typography>
          <Typography paragraph>
            When you interact with our platform, we may collect:
            <ul>
              <li>Your name and email address (e.g. if you join the waitlist).</li>
              <li>Your responses to optional fields like favourite artist, streaming platform, or country.</li>
              <li>Your IP address and browser type for security and analytics purposes.</li>
            </ul>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            How We Use Your Data
          </Typography>
          <Typography paragraph>
            We use your data to:
            <ul>
              <li>Contact you with news, early access invitations, and updates.</li>
              <li>Understand our user base and improve our product direction.</li>
              <li>Prevent abuse, fraud, and maintain platform integrity.</li>
            </ul>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Data Sharing & Third Parties
          </Typography>
          <Typography paragraph>
            We do not sell your data. We may share it with service providers like email platforms or analytics tools to help us operate effectively.
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Cookies & Tracking
          </Typography>
          <Typography paragraph>
            We use cookies and similar technologies to monitor site usage. You can control cookies via your browser settings.
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Your Rights
          </Typography>
          <Typography paragraph>
            You have the right to:
            <ul>
              <li>Access or delete your data on request.</li>
              <li>Update or correct any inaccurate information.</li>
              <li>Withdraw from communications at any time.</li>
            </ul>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Changes to This Policy
          </Typography>
          <Typography paragraph>
            We may revise this policy in the future. Substantial changes will be clearly communicated on this page.
          </Typography>

          <Typography sx={{ mt: 4 }}>
            If you have any questions or requests, contact us at <strong>support@lsnto.com</strong>.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default ArtistRights;
